import { render, staticRenderFns } from "./ClaimHelperMenu.vue?vue&type=template&id=3140e8bf&"
import script from "./ClaimHelperMenu.vue?vue&type=script&lang=js&"
export * from "./ClaimHelperMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports